import * as z from "zod";

import { additionalFieldWithLabelSchema } from "./additional-field";
import { contactSchema } from "./contact";
import { entityFileTypeSchema } from "./entity-file-type";
import { socialLinksSchema } from "./social-link";
import { surrealRecordSchema } from "./surreal-record";

export const associationContactTitleSchema = z.object({
  language: z.string(),
  value: z.string(),
});

export const associationIntegrationSchema = z.object({
  fastum: z.boolean().optional(),
});

export type AssociationContactTitle = z.infer<
  typeof associationContactTitleSchema
>;

export const associationFloorMapLabelSchema = z.object({
  language: z.string(),
  value: z.string(),
});

export const associationFloorMapEntrySchema = z.object({
  floor: z.string(),
  label: z.array(associationFloorMapLabelSchema),
});

export const associationFloorMapSchema = z.array(
  associationFloorMapEntrySchema,
);

export type AssociationFloorMapLabel = z.infer<
  typeof associationFloorMapLabelSchema
>;
export type AssociationFloorMapEntry = z.infer<
  typeof associationFloorMapEntrySchema
>;
export type AssociationFloorMap = z.infer<typeof associationFloorMapSchema>;

export const associationSchema = surrealRecordSchema.extend({
  name: z.string(),
  domain: z.string(),
  organizationNumber: z.string(),
  contacts: z.array(contactSchema).optional(),
  socialLinks: socialLinksSchema.optional(),
  integrations: associationIntegrationSchema.optional(),
  availableLanguages: z.array(z.string()),
  primaryLanguage: z.string(),
  additionalFields: z.array(additionalFieldWithLabelSchema).optional(),
  entityFileTypes: z.array(entityFileTypeSchema).optional(),
  floorMap: associationFloorMapSchema.optional(),
});

export type Association = z.infer<typeof associationSchema>;
